import '../../style/index.less';
import './index.less';
import "../../style/nsky/reset/tag/index.less";



/** WEBPACK FOOTER **
 ** ./components/tag/style/index.js
 **/